export const BASEURL =
  process.env.REACT_APP_API_BASE_URL || 'https://svasth.ai/api/v1'
export const ENDPOINT = {
  CREATE_ALEGION_CONTACT: '/alegioncontact/',
};

export default BASEURL;
